import React from "react";
import { FaAward, FaRedo, FaUserFriends } from "react-icons/fa";
import { GiBlackBelt } from "react-icons/gi";

function StatPill({ label, value }) {
  return (
    <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
      <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
        {label}
      </p>
      <p className="mt-2 font-titre text-3xl font-bold">{value}</p>
    </div>
  );
}

function CoachGradeHero({ stats, refreshing, onRefresh }) {
  return (
    <header className="relative overflow-hidden bg-slate-950 pt-[88px] lg:pt-[104px]">
      <div className="absolute inset-0">
        <img
          src="https://www.ffjudo.com/photo-actualite/1766160752_59b099ca041b06168b2f.jpg/1400/400/1/separation-des-grades-judo-et-jujitsu-une-evolution-majeure-pour-le-jujitsu.webp"
          alt="Passages de grades"
          className="h-full w-full object-cover opacity-75"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-blue-950/90 to-indigo-950/80" />
      </div>

      <div className="relative mx-auto w-full max-w-[1280px] px-4 pb-20 pt-10 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
              <GiBlackBelt />
              Espace coach
            </div>

            <h1 className="mt-5 font-titre text-4xl font-bold tracking-tight text-white sm:text-5xl">
              Passages de grades
            </h1>

            <p className="mt-4 max-w-3xl text-sm font-medium leading-7 text-white/70 sm:text-base">
              Suis les ceintures de tes judokas, filtre par groupe ou grade et
              ouvre l'historique complet d'un adhérent en un clic.
            </p>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-white/15 bg-white/10 px-5 py-3 text-sm font-bold text-white backdrop-blur-xl transition hover:-translate-y-0.5 hover:bg-white/15 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaRedo className={refreshing ? "animate-spin" : ""} />
            {refreshing ? "Actualisation..." : "Actualiser"}
          </button>
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <StatPill label="Judokas" value={stats.totalJudokas} />
          <StatPill label="Avec ceinture" value={stats.withBelt} />
          <StatPill label="À renseigner" value={stats.withoutBelt} />
          <StatPill label="Passages" value={stats.totalGrades} />
        </div>
      </div>
    </header>
  );
}

export default CoachGradeHero;